"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isElementVisible = exports.getKeyboardFocusableElements = void 0;
const isElementVisible = element => {
  const style = window.getComputedStyle(element);
  return style.display !== 'none' && style.visibility !== 'hidden';
};
exports.isElementVisible = isElementVisible;
const getKeyboardFocusableElements = element => {
  const hasVisibleParents = el => {
    let parentElement = el.parentElement;
    while (parentElement) {
      if (!isElementVisible(parentElement) || parentElement.getAttribute('aria-hidden') === 'true') {
        return false;
      }
      parentElement = parentElement.parentElement;
    }
    return true;
  };
  return [...element.querySelectorAll('a[href], button, input, textarea, select, details,[tabindex]:not([tabindex="-1"])')].filter(el => !el.hasAttribute('disabled') && el.getAttribute('aria-hidden') !== 'true' && isElementVisible(el) && hasVisibleParents(el));
};
exports.getKeyboardFocusableElements = getKeyboardFocusableElements;